var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('request-form',{attrs:{"loading":_vm.loading,"requestData":_vm.request,"formErrors":_vm.formErrors},on:{"requestSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }